var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"copyright"},[_vm._v("\n      © "+_vm._s(_vm.year)+", Digital Aggregator LLC.\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }